<template>
  <div class="revision-list d-flex flex-column w-100">
    <!-- Revisions -->
    <div
      v-for="(revision, index) in revisions"
      :key="revision.id"
      class="revision-item d-flex ga-2 px-6 align-center cursor-pointer position-relative"
      :class="{ 'read-only': index === 0 }"
      @click="emit('revision-click', { revision, index })"
    >
      <!-- Timeline -->
      <div class="timeline-indicator d-flex align-center justify-center flex-shrink-0 position-relative h-100">
        <div
          v-if="revisions.length > 1"
          class="timeline-line position-absolute"
        />
        <div class="timeline-dot position-absolute rounded-circle" />
      </div>

      <!-- Content -->
      <div class="py-4 d-flex flex-column ga-2 flex-grow-1">
        <!-- Revision details -->
        <RevisionListItem :revision="{ ...revision, index }">
          <template #before-revision-item>
            <slot name="before-revision-item" :revision="revision" />
          </template>
        </RevisionListItem>
      </div>
    </div>
  </div>
</template>

<script setup>
import RevisionListItem from './RevisionListItem.vue';

defineProps({
  revisions: {
    type: Array,
    required: true,
    default: () => [],
  },
});

const emit = defineEmits(['revision-click']);
</script>

<style lang="less" scoped>
.revision-item {
  &:not(.read-only):hover {
    background-color: @indigo-100;
  }

  &.read-only {
    cursor: default;
    pointer-events: none;
  }

  .timeline-indicator {
    width: 9px;
  }

  .timeline-line {
    width: 1px;
    background-color: @stroke-dark;
    height: 150px;
  }

  &:first-child .timeline-line {
    height: 100px;
    top: 50%;
  }

  &:last-child .timeline-line {
    height: 100px;
    bottom: 50%;
  }

  .timeline-dot {
    width: 10px;
    height: 10px;
    border: 1px solid @stroke-dark;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    background-color: @white;
  }
}
</style>
